export const domain = typeof window !== 'undefined' && window.location.hostname === 'localhost' ? undefined : '.kbb.com';
export const ZipCodeCookie = 'ZipCode';
export const PersistentZipCodeCookie = 'PersistentZipCode';
export const ZipCodeAkamaiCookie = 'AkamaiZip';
export const LocationCookie = 'kbb-location-data';
export const LocalStorageZipInfo = 'kbb-location';
export const LocalStorageGeoInfo = 'kbb-geolocation';
export const zipCodeExtractRegex = /[\-\+]/g;
export const akamaiHeader = 'x-akamai-edgescape';
export const AkamaiLocationHeader = 'x-akamai-edgescape';
export const AkamaiDeviceHeader = 'x-akamai-device-characteristics';
export const AkamaiSessionInfo = 'x-akamai-session-info';
export const isDevelopment = process.env.NODE_ENV === 'development';